/*
 * 文件下载
 * author: izzieyspu
 * time: 2020-02-10
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, PopOver, OverlayTrigger, Dropdown, DropdownToggle, DropdownContent } from '@tencent/spaui';
import { createDownloadTask } from '@/api/operator/cgi/smb/download';
import cookie from '@/utils/cookie';
import { downloadConfig } from './config';
import animate from '@/utils/animate';
import message from '@/utils/message';
import { reportUserBehavior } from '@/pages/agency/utils/util';
import { getParentSonList } from '@/api/operator/cgi/smb/manage/account';
import './index.scoped.less';
import globalStore from '@/stores/index';
import CrossAgencyDownload from './CrossAgencyDownload/index';
import _ from 'lodash';

class Download extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      downloadType: props.downloadType || 'default',
      selected_agency_uid_obj: {},
      allAgencyList: null,
    };

    this.download = this.download.bind(this);
    this.handleShowChange = this.handleShowChange.bind(this);
    this.handleCloseChange = this.handleCloseChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.downloadType !== this.props.downloadType) {
      this.setState({
        downloadType: nextProps.downloadType,
      });
    }
  }

  getAllAgencyList = () => {
    const { downloadType } = this.state;
    const {
      account: { bm_id },
    } = globalStore;

    if (downloadType === 'newSeenOld') {
      const data = {
        bm_id,
        agency_uid: 0,
      };
      return getParentSonList({ data }, true).then((res) => {
        this.setState({ allAgencyList: res.data?.list });
      });
    }
  }

  /**
   *
   * @param downloadType default | multi | newSeenOld
   */
  download(downloadType) {
    const {
      type, param: _params, getParams, agencyUid = 0, conditions = false, conditionsMsg = '', conditionsFunc,
      isCrossAgencyDownLoad, isNewSeenOld, needReturnFields, nameRender: customNameRender, onSuccess,
    } = this.props;
    const param = _.isFunction(getParams) ? getParams() : _params;
    const isMulti = downloadType === 'multi';

    if (!downloadConfig[type]) {
      message.strongwarn('缺少下载配置');
      return;
    }
    if (needReturnFields && !param.return_fields) {
      message.strongwarn('请在表格表头加载完后点击下载');
      return;
    }
    if (conditions) {
      if (conditionsMsg) {
        message.strongwarn(conditionsMsg);
      }
      return;
    }
    if (_.isFunction(conditionsFunc)) {
      const condMsg = conditionsFunc();
      if (condMsg) {
        message.strongwarn(condMsg);
        return;
      }
    }
    const agency_uid_list = [];
    _.values(this.state.selected_agency_uid_obj).map((x) => {
      agency_uid_list.push(...x);
    });
    const currentDownloadConfig = downloadConfig[type] || {};
    const { name = '报表', mod } = currentDownloadConfig;
    let taskName = name;
    if (param?.industry_id_list && typeof param?.industry_id_list === 'string') {
      param.industry_id_list = JSON.parse(param.industry_id_list);
    }
    if (param.uid_list && typeof param.uid_list === 'string') {
      param.uid_list = JSON.parse(param.uid_list);
    }
    if (param.appid_list && typeof param.appid_list === 'string') {
      param.appid_list = JSON.parse(param.appid_list);
    }
    if (downloadType !== 'default') {
      if (isCrossAgencyDownLoad || isNewSeenOld) {
        if (!agency_uid_list?.length) {
          message.strongwarn('请选择服务商');
          return;
        }
      }
      param.agency_uid_list = agency_uid_list;
    }

    reportUserBehavior({ behaviorType: '下载数据' });

    animate({
      source: `#download-mask${type}`,
      target: '#download',
      show: true,
      display: 'flex',
      duration: 2000,
      easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
      delay: 100,
      onError: () => {
        this.setState({ show: true });
      },
    });

    let nameRender = customNameRender || currentDownloadConfig.nameRender;
    let action = currentDownloadConfig.action;
    switch (downloadType) {
      case 'multi':
        nameRender = currentDownloadConfig.multiNameRender;
        action = currentDownloadConfig.multiAction;
        break;
      case 'newSeenOld':
        nameRender = currentDownloadConfig.newSeenOldNameRender;
        action = currentDownloadConfig.newSeenOldAction;
        break;
    }

    if (nameRender && typeof nameRender === 'function') {
      taskName = nameRender({ ...param, isMulti, agencyUid });
    } else {
      const nameParams = name.match(/[^\{\}]+(?=\})/g);
      nameParams?.forEach((key) => {
        taskName = taskName.replace(`{${key}}`, param[key] || '-');
      });
    }
    const bm_id = cookie.get('bm_id');
    const agency_uid = cookie.get('agency_uid');
    const taskSpec = {
      bm_id: +(bm_id || 0),
      ...param,
    };
    if (taskSpec.agency_uid === undefined || taskSpec.agency_uid === null) {
      taskSpec.agency_uid = +(agency_uid || 0);
    }
    Object.keys(taskSpec).forEach((v) => {
      if (taskSpec[v] === '' || (Array.isArray(taskSpec[v]) && !taskSpec[v].length)) {
        delete taskSpec[v];
      }
    });
    const data = {
      task_name: taskName,
      task_type: `${mod}_${action}`,
      task_spec: JSON.stringify(taskSpec),
    };
    createDownloadTask({ data }).then((res) => {
      const { code, msg = '创建离线任务失败' } = res;
      if (code !== 0) {
        message.strongwarn(msg);
      } else {
        onSuccess?.();
      }
    });
  }

  // 关闭提示
  handleCloseChange() {
    this.setState({
      show: false,
      selected_agency_uid_obj: {},
    });
  }

  handleShowChange(event, show = false) {
    const { conditions = false } = this.props;
    this.setState({
      show: conditions ? false : show,
    });
  }

  // 跨服务商下载弹框展示
  crossAgencyDownload = (downloadType) => {
    this.setState(
      {
        dialogShow: true,
        downloadType,
      },
      () => this.getAllAgencyList(),
    );
  }

  handleDialogShow = (show) => {
    const { param: _params, getParams } = this.props;
    const queryDataValue = _.isFunction(getParams) ? getParams() : _params;
    this.setState({
      dialogShow: show,
      queryDataValue,
      selected_agency_uid_obj: {},
    });
  }

  // 处理待选择的服务商
  handleAgency = (noNeedFilter, external_agency_list) => {
    let agency_list = external_agency_list || globalStore.account.agency_list || [];
    const { type } = this.props;
    agency_list = agency_list.filter((x) => {
      if (x.ad_platform_type == 1) {
        if (downloadConfig[type]?.isCps) {
          return x.ad_platform_type == downloadConfig[type]?.ad_platform_type && x.is_cps;
        }
        return x.ad_platform_type == downloadConfig[type]?.ad_platform_type && !x.is_cps;
      }
      return x.ad_platform_type == downloadConfig[type]?.ad_platform_type;
    });
    if (noNeedFilter) {
      return agency_list;
    }
    const obj = agency_list.reduce((prev, curr) => {
      if (curr.parent_agency_uid) {
        if (prev[curr.parent_agency_uid]) {
          const obj = {
            ...curr,
            label: curr.remark ? curr.remark : curr.spid ? `${curr.agency_uid}(${curr.spid})` : curr.agency_uid,
            value: curr.agency_uid,
          };
          prev[curr.parent_agency_uid].push(obj);
        } else {
          const obj = {
            ...curr,
            label: curr.remark ? curr.remark : curr.spid ? `${curr.agency_uid}(${curr.spid})` : curr.agency_uid,
            value: curr.agency_uid,
          };
          prev[curr.parent_agency_uid] = [obj];
        }
      }
      return {
        ...prev,
      };
    }, {});
    return agency_list
      .filter((x) => !x.parent_agency_uid)
      .map((x) => {
        return {
          ...x,
          value: x.agency_uid,
          label: x.remark ? x.remark : x.spid ? `${x.agency_uid}(${x.spid})` : x.agency_uid,
          data: obj[x.agency_uid],
        };
      });
  }

  // 选择服务商后点下载
  handleChooseAgencySubmit = () => {
    this.handleDialogShow(false);
    this.handleSubmit();
  }

  handleSubmit = () => {
    this.download(this.state.downloadType);
  }

  handleSelectedAgency = (n, val) => {
    const { selected_agency_uid_obj } = this.state;
    selected_agency_uid_obj[n] = val;
    this.setState({
      selected_agency_uid_obj,
    });
  }

  render() {
    const { label = '下载数据', className = '', style = {}, type, isCrossAgencyDownLoad, showQueryCond = true, isNewSeenOld, needIcon = true, reportKey, children } = this.props;
    const { queryDataValue } = this.state;
    const {
      account: { feature_flag_list, agency_uid, bm_id },
    } = globalStore;
    const agency_list = this.handleAgency(true);
    const agency_list_noFilter = this.handleAgency();
    const all_agency_list_noFilter = this.handleAgency(false, this.state.allAgencyList);
    const { show, dialogShow, downloadType } = this.state;
    const isShowCrossAgency = agency_list.length !== 1 && isCrossAgencyDownLoad;
    const isShowNewSeenOld = feature_flag_list?.[agency_uid || bm_id]?.is_advertiser_new_and_old_rpt_enable && isNewSeenOld;

    const popover = (
      <PopOver className="dark">
        <h4 className="spaui-popover-title">请在“下载中心”查看下载结果</h4>
        <div className="spaui-popover-body"></div>
        <Button displayType="primary" onClick={this.handleCloseChange}>
          我知道了
        </Button>
      </PopOver>
    );
    return (
      <React.Fragment>
        <CrossAgencyDownload
          downloadType={downloadType}
          type={type}
          agency_list={downloadType === 'newSeenOld' ? all_agency_list_noFilter : agency_list_noFilter}
          handleDialogShow={this.handleDialogShow}
          onChange={this.handleSelectedAgency}
          handleSubmit={this.handleChooseAgencySubmit}
          customTagsName={this.props.customTagsName}
          queryDataValue={queryDataValue}
          show={dialogShow}
          showQueryCond={showQueryCond}
        />
        {isShowCrossAgency || isShowNewSeenOld ? (
          <OverlayTrigger trigger="click" overlay={popover} show={show}>
            <Dropdown trigger="hover" documentClickAutoHide alignment="right" offsetData={{ top: 4 }}>
              <DropdownToggle>
                <Button className={`borderless ${className}`} style={style}>
                  {needIcon && <i className="toolbar-icon spaui-icon icon-download" />}
                  {label}
                  <div id={`download-mask${type}`} className="download-mask">
                    <i className="spaui-icon spaui-icon-buttonin">
                      <Icon name="download-outlined" />
                    </i>
                  </div>
                </Button>
              </DropdownToggle>
              <DropdownContent
                className="spaui-dropmenu"
                style={{
                  width: 162,
                  zIndex: 100,
                  borderRadius: 6,
                  background: '#fff',
                  border: '1px solid #ccc',
                }}
              >
                <ul className="spaui-submenu">
                  <li className="spaui-menuitem" onClick={(e) => this.download('default')} data-report="download-current">
                    <a className="">
                      <span className="spaui-menu-text" title="当前服务商下载">
                        当前服务商下载
                      </span>
                    </a>
                  </li>
                  {isShowCrossAgency ? (
                    <li className="spaui-menuitem" onClick={() => this.crossAgencyDownload('multi')} data-report="download-multi">
                      <a className="">
                        <span className="spaui-menu-text" title="批量服务商下载">
                          批量服务商下载
                        </span>
                      </a>
                    </li>
                  ) : null}

                  {isShowNewSeenOld ? (
                    <li className="spaui-menuitem" onClick={() => this.crossAgencyDownload('newSeenOld')} data-report="download-old">
                      <a className="">
                        <span className="spaui-menu-text" title="批量服务商下载">
                          迁移前数据下载
                        </span>
                      </a>
                    </li>
                  ) : null}
                </ul>
              </DropdownContent>
            </Dropdown>
          </OverlayTrigger>
        ) : (
          <OverlayTrigger trigger="click" overlay={popover} show={show}>
            <Button className={`borderless ${className}`} style={style} onClick={this.handleSubmit} data-report="download" {...reportKey || {}}>
              {children || <>
                {needIcon && <i className="toolbar-icon spaui-icon icon-download" />}
                {label}
              </>}
              <div id={`download-mask${type}`} className="download-mask">
                <i className="spaui-icon spaui-icon-buttonin">
                  <Icon name="download-outlined" />
                </i>
              </div>
            </Button>
          </OverlayTrigger>
        )}
      </React.Fragment>
    );
  }
}

Download.propTypes = {
  // 下载类型，支持 default, multi, newSeenOld,
  downloadType: PropTypes.string,
  /* 组件类名 */
  className: PropTypes.string,
  /* 样式 */
  style: PropTypes.object,
  /* 按钮文案 */
  label: PropTypes.string,
  /* 下载类型 */
  type: PropTypes.string,
  /* 下载参数 */
  param: PropTypes.object,
  /* 获取下载参数 */
  getParams: PropTypes.func,
  /* 服务商UID */
  agencyUid: PropTypes.number,
  /* 需要ID，这个参数已经不再需要，应该删掉 */
  needId: PropTypes.bool,
  /* 提示 */
  conditions: PropTypes.bool,
  /* 提示文案 */
  conditionsMsg: PropTypes.string,
  /* 条件校验 */
  conditionsFunc: PropTypes.func,
  /* 是否展示迁移前数据下载按钮 */
  isNewSeenOld: PropTypes.bool,
  /* 按钮是否需要icon */
  needIcon: PropTypes.bool,
  /* 是否需要return_fields */
  needReturnFields: PropTypes.bool,
  /* data-report上报key，默认为空 */
  reportKey: PropTypes.object,
  /* 自定义下载名称 */
  nameRender: PropTypes.func,
  /* 下载成功回调 */
  onSuccess: PropTypes.func,
};

Download.defaultProps = {
  downloadType: 'default',
  label: '下载数据',
  style: {},
  param: {},
  agencyUid: 0,
  needId: false,
  conditions: false,
  conditionsMsg: '',
  isNewSeenOld: false,
  needIcon: true,
  needReturnFields: false,
};

export default Download;
